import { AxiosError } from 'axios';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOptionsForBinary } from '../../../hooks/api';
import { usePostManualsDownloadall } from '../../../api/manual/manual';
import BlobErrorModal from '../../modules/BlobErrorModal';
import SpinnerModal from '../../modules/SpinnerModal';
import { executeDownload } from '../../../utils/download';
import { Manual } from '../../../api/model';

type Props = {
  manuals: Manual[];
};
function ManualDownloadAll({ manuals }: Props) {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [displaySpinnerModal, setDisplaySpinnerModal] = useState(false);
  const [displayDownloadError, setDisplayDownloadError] = useState(false);
  const optionsForBinary = useOptionsForBinary(language);

  const { mutateAsync: _downloadAsync, error: downloadError } =
    usePostManualsDownloadall<AxiosError<Blob>>(optionsForBinary);

  // ダウンロード処理
  const downloadAsync = useCallback(async () => {
    setDisplaySpinnerModal(true);
    const response = await _downloadAsync();
    if (response.status === 200) {
      executeDownload(response);
      setDisplaySpinnerModal(false);
    } else {
      setDisplaySpinnerModal(false);
    }
  }, [_downloadAsync]);

  const isEnableDownload = useMemo(() => manuals.length > 0, [manuals]);

  return (
    <>
      <li
        onClick={() => isEnableDownload && downloadAsync()}
        style={{ cursor: isEnableDownload ? 'pointer' : 'not-allowed', color: isEnableDownload ? '' : '#bdb7b7' }}
      >
        <i
          className="fa-solid fa-download"
          style={{ cursor: isEnableDownload ? 'pointer' : 'not-allowed', color: isEnableDownload ? '' : '#bdb7b7' }}
        />
        {t('ダウンロード')}
      </li>
      {/* スピナーモーダル */}
      {displaySpinnerModal && <SpinnerModal />}
      {/* 出力エラー */}
      {displayDownloadError && (
        <BlobErrorModal error={downloadError} onClickOk={() => setDisplayDownloadError(false)} />
      )}
    </>
  );
}

export { ManualDownloadAll };
